import { request } from "./transport";

export type QuizBoard = "beginner" | "intermediate" | "advanced";
export type QuizCategory =
  | "Basics"
  | "Payoff"
  | "Greeks"
  | "Volatility"
  | "Strategies"
  | "Risk";

export interface QuizQuestionPayload {
  readonly id: string;
  readonly board: QuizBoard;
  readonly category: QuizCategory;
  readonly prompt: string;
  readonly choices: readonly string[];
  readonly answer_index: number;
  readonly explanation: string;
  readonly updated_at: string;
}

export const quiz = {
  listQuizQuestions: (params?: { board?: QuizBoard; locale?: string }) => {
    const qs = new URLSearchParams();
    if (params?.board) qs.set("board", params.board);
    if (params?.locale) qs.set("locale", params.locale);
    const q = qs.toString();
    return request<{ questions: QuizQuestionPayload[] }>(
      `/quiz_questions${q ? `?${q}` : ""}`,
    );
  },
};
